import { useQuery } from '@tanstack/react-query';
import { cva, cx, type VariantProps } from '@/cva.config';
import { renderMarkdown } from '@/server/markdown.functions';

const markdownVariants = cva({
  defaultVariants: {
    tone: 'dark',
  },
  variants: {
    tone: {
      dark: 'prose prose-sm max-w-none prose-invert prose-headings:text-foreground prose-p:text-foreground-muted prose-a:text-accent prose-strong:text-foreground prose-li:text-foreground-muted',
      light:
        'prose prose-sm max-w-none prose-headings:text-foreground-document prose-p:text-foreground-document prose-a:text-accent prose-strong:text-foreground-document prose-li:text-foreground-document',
    },
  },
});

interface MarkdownProps extends VariantProps<typeof markdownVariants> {
  className?: string;
  content: string;
}

export const Markdown = ({ content, tone, className }: MarkdownProps) => {
  const { data } = useQuery({
    queryFn: () => renderMarkdown({ data: { md: content } }),
    queryKey: ['markdown', content],
    staleTime: Number.POSITIVE_INFINITY,
  });

  return (
    <div
      className={cx(markdownVariants({ tone }), className)}
      // biome-ignore lint/security/noDangerouslySetInnerHtml: HTML is sanitized server-side via DOMPurify in renderMarkdown
      dangerouslySetInnerHTML={{ __html: data?.html ?? '' }}
    />
  );
};
